var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export default function CreateTestConfig(logMessage, config) {
    return __awaiter(this, void 0, void 0, function () {
        var ua, isSafari;
        return __generator(this, function (_a) {
            // Copy config.json to static files dir of your client to work with it
            try {
                ua = navigator.userAgent;
                // quirks for specific browsers. apply only if not overridden. more may be added in future releases
                if (config.enableQuirks) {
                    if (/Firefox.(\d+\.\d+)/i.test(ua)) {
                        config.xhrUlMultistream = 1;
                    }
                    if (/Edge.(\d+\.\d+)/i.test(ua)) {
                        // edge more precise with 3 download streams
                        config.xhrDlMultistream = 3;
                    }
                    if (/Chrome.(\d+)/i.test(ua) && !!self.fetch) {
                        // chrome more precise with 5 streams
                        config.xhrDlMultistream = 5;
                    }
                }
                isSafari = ua.search("Safari") >= 0 && ua.search("Chrome") < 0;
                if (/Edge.(\d+\.\d+)/i.test(ua) || isSafari) {
                    // Edge 15 introduced a bug that causes onprogress events to not get fired,
                    // we have to use the "small chunks" workaround that reduces accuracy
                    // same issue was found (Dec 16 2020) for Safari
                    config.forceIE11Workaround = true;
                }
                if (/Chrome.(\d+)/i.test(ua) && /Android|iPhone|iPad|iPod|Windows Phone/i.test(ua)) {
                    // cheap af
                    // Chrome mobile introduced a limitation somewhere around version 65,
                    // we have to limit XHR upload size to 4 megabytes
                    config.xhrUlBlobMegabytes = 4;
                }
            }
            catch (e) {
                logMessage("Possible error in custom test settings.\n    Some settings may not be applied. Exception: " + e, "red", true);
            }
            return [2 /*return*/, config];
        });
    });
}
//# sourceMappingURL=createTestConfig.js.map